export const REMOVE_CAPITULOS = 'REMOVE_CAPITULOS';
export const SET_CAPITULOS = 'SET_CAPITULOS';
export const ADD_CAPITULOS = 'ADD_CAPITULOS';
export const UPDATE_CAPITULOS = 'UPDATE_CAPITULOS';
export const SET_CAPITULO = 'SET_CAPITULO';